
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[sort_url]",
      function () {
        return require("private-next-pages/blog/[sort_url].js");
      }
    ]);
  